import { render, staticRenderFns } from "./_base-modal-layout.vue?vue&type=template&id=58735b12&scoped=true"
import script from "./_base-modal-layout.vue?vue&type=script&lang=js"
export * from "./_base-modal-layout.vue?vue&type=script&lang=js"
import style0 from "./_base-modal-layout.vue?vue&type=style&index=0&id=58735b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58735b12",
  null
  
)

export default component.exports